import Controller from "controllers/application_controller"

export default class extends Controller {
  static identifier = "ui-filter-list"
  static targets = ["glyph", "op", "panel", "query", "summary", "trigger"]
  static values = {
    paramName: String,
    placeholder: String
  }

  connect() {
    this.updateOp()
    this.updateSummary()

    this.addEventListener(document, "mousedown", event => {
      if (!this.element.contains(event.target)) this.close()
    })
    this.addEventListener(document, "keydown", event => {
      if (event.key === "Escape") this.close()
    })
  }

  toggle(event) {
    event.preventDefault()

    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.panelTarget.hidden = false
    this.triggerTarget.setAttribute("aria-expanded", "true")

    const searchInput = this.element.querySelector(".ui-form-multiselect__search")
    const initialControl = searchInput || this.triggerTarget
    initialControl.focus()
  }

  close() {
    this.panelTarget.hidden = true
    this.triggerTarget.setAttribute("aria-expanded", "false")
  }

  updateOp() {
    this.glyphTargets.forEach(glyph => {
      glyph.hidden = glyph.dataset.opValue !== this.opTarget.value
    })

    this.updateQuery()
  }

  updateSummary() {
    const checked = this.element.querySelectorAll("input[type='checkbox']:checked")
    const summary = this.summary(checked)

    this.summaryTarget.textContent = summary
    this.summaryTarget.classList.toggle("text-gray-400", summary === this.placeholderValue)
    this.updateQuery()
  }

  updateQuery() {
    const checked = this.element.querySelectorAll("input[type='checkbox']:checked")
    const values = Array.from(checked).map(input => input.value).filter(Boolean)

    this.queryTarget.name = this.opTarget.value === "not_in" ? `-${this.paramNameValue}` : this.paramNameValue
    this.queryTarget.value = values.join(" ")
    this.queryTarget.disabled = values.length === 0
  }

  summary(checked) {
    if (checked.length === 0) return this.placeholderValue

    const labels = Array.from(checked).map(input => input.closest("label")?.textContent.trim() || "")

    if (checked.length === 1) return labels[0]
    if (checked.length === 2) return `${labels[0]} or ${labels[1]}`

    return `${labels[0]} or ${labels[1]} or ${checked.length - 2} more`
  }

  get isOpen() {
    return !this.panelTarget.hidden
  }
}
